import cx from 'classnames';
import React from 'react';
import { TextColors } from '../../utilities/Color.js';
import { IconProps, IconSize, Icons } from './Icon.types.js';
import AIEnabled from './svgs/AIEnabled.js';
import Add from './svgs/Add.js';
import AdminPanelOutline from './svgs/AdminPanelOutline.js';
import ArrowDownward from './svgs/ArrowDownward.js';
import ArrowForward from './svgs/ArrowForward.js';
import Assignment from './svgs/Assignment.js';
import BulkAction from './svgs/BulkAction.js';
import Calendar from './svgs/Calendar.js';
import Cancel from './svgs/Cancel.js';
import CheckBox from './svgs/CheckBox.js';
import CheckBoxOutlineBlank from './svgs/CheckBoxOutlineBlank.js';
import CheckCircle from './svgs/CheckCircle.js';
import CheckCircleOutline from './svgs/CheckCircleOutline.js';
import Circle from './svgs/Circle.js';
import Close from './svgs/Close.js';
import ContentCopy from './svgs/ContentCopy.js';
import Description from './svgs/Description.js';
import DollarSign from './svgs/DollarSign.js';
import Edit from './svgs/Edit.js';
// biome-ignore lint/suspicious/noShadowRestrictedNames: Icon name
import Error from './svgs/Error.js';
import ErrorOutline from './svgs/ErrorOutline.js';
import FastForward from './svgs/FastForward.js';
import FilterList from './svgs/FilterList.js';
import Flag from './svgs/Flag.js';
import GppGoodOutlined from './svgs/GppGoodOutlined.js';
import Help from './svgs/Help.js';
import Home from './svgs/Home.js';
import Info from './svgs/Info.js';
import InfoOutline from './svgs/InfoOutline.js';
import KeyboardArrowDown from './svgs/KeyboardArrowDown.js';
import KeyboardArrowLeft from './svgs/KeyboardArrowLeft.js';
import KeyboardArrowRight from './svgs/KeyboardArrowRight.js';
import KeyboardArrowUp from './svgs/KeyboardArrowUp.js';
import Language from './svgs/Language.js';
import LockOpen from './svgs/LockOpen.js';
import LogOut from './svgs/LogOut.js';
import Mail from './svgs/Mail.js';
import MarkEmailRead from './svgs/MarkEmailRead.js';
import Menu from './svgs/Menu.js';
import Money from './svgs/Money.js';
import MoreDots from './svgs/MoreDots.js';
import NewApplicant from './svgs/NewApplicant.js';
import Profile from './svgs/Profile.js';
import Pin from './svgs/PushPin.js';
import PinOutlined from './svgs/PushPinOutlined.js';
import RadioButtonUnchecked from './svgs/RadioButtonUnchecked.js';
import RaisedHandOutlined from './svgs/RaisedHandOutlined.js';
import Referral from './svgs/Referral.js';
import ReportGmailErrorRed from './svgs/ReportGmailErrorRedIcon.js';
import Save from './svgs/Save.js';
import Search from './svgs/Search.js';
import SyncAlt from './svgs/SyncAlt.js';
import Task from './svgs/Task.js';
import ThumbDown from './svgs/ThumbDown.js';
import ThumbDownOutline from './svgs/ThumbDownOutline.js';
import ThumbUp from './svgs/ThumbUp.js';
import ThumbUpOutline from './svgs/ThumbUpOutline.js';
import Time from './svgs/Time.js';
import Trash from './svgs/Trash.js';
import Unverified from './svgs/Unverified.js';
import Upload from './svgs/Upload.js';
import UploadDoneOutline from './svgs/UploadDoneOutline.js';
import User from './svgs/User.js';
import Verified from './svgs/Verified.js';
import VerifiedOutlined from './svgs/VerifiedOutlined.js';
import Visibility from './svgs/Visibility.js';
import Warning from './svgs/Warning.js';
import WarningOutline from './svgs/WarningOutline.js';

const icons: Icons = {
  add: Add,
  adminPanelOutline: AdminPanelOutline,
  aiEnabled: AIEnabled,
  arrowDownward: ArrowDownward,
  arrowForward: ArrowForward,
  assignment: Assignment,
  bulkAction: BulkAction,
  calendar: Calendar,
  cancel: Cancel,
  checkBox: CheckBox,
  checkBoxOutlineBlank: CheckBoxOutlineBlank,
  checkCircle: CheckCircle,
  checkCircleOutline: CheckCircleOutline,
  circle: Circle,
  close: Close,
  contentCopy: ContentCopy,
  description: Description,
  dollarSign: DollarSign,
  edit: Edit,
  error: Error,
  errorOutline: ErrorOutline,
  fastForward: FastForward,
  filterList: FilterList,
  flag: Flag,
  gppGoodOutlined: GppGoodOutlined,
  help: Help,
  home: Home,
  info: Info,
  infoOutline: InfoOutline,
  keyboardArrowDown: KeyboardArrowDown,
  keyboardArrowLeft: KeyboardArrowLeft,
  keyboardArrowRight: KeyboardArrowRight,
  keyboardArrowUp: KeyboardArrowUp,
  language: Language,
  lockOpen: LockOpen,
  logout: LogOut,
  mail: Mail,
  markEmailRead: MarkEmailRead,
  menu: Menu,
  money: Money,
  moreDots: MoreDots,
  newApplicant: NewApplicant,
  raisedHandOutlined: RaisedHandOutlined,
  pin: Pin,
  pinOutlined: PinOutlined,
  profile: Profile,
  radioButtonUnchecked: RadioButtonUnchecked,
  referral: Referral,
  reportGmailErrorRed: ReportGmailErrorRed,
  save: Save,
  search: Search,
  syncAlt: SyncAlt,
  task: Task,
  thumbDown: ThumbDown,
  thumbDownOutline: ThumbDownOutline,
  thumbUp: ThumbUp,
  thumbUpOutline: ThumbUpOutline,
  time: Time,
  trash: Trash,
  upload: Upload,
  UploadDoneOutline: UploadDoneOutline,
  user: User,
  unverified: Unverified,
  verifiedOutlined: VerifiedOutlined,
  verified: Verified,
  view: Visibility,
  warning: Warning,
  warningOutline: WarningOutline,
};

const Icon = ({ type, color, size, className, responsiveSize }: IconProps): JSX.Element => {
  if (!(type in icons)) {
    return <span>{type} Icon not available</span>;
  }

  const Component: React.ElementType = icons[type];

  return (
    <span
      className={cx(`inline-flex ${IconSize[size]} leading-none`, className, {
        [TextColors[color]]: color,
        [IconSize[responsiveSize]]: responsiveSize,
      })}
      data-cy={type}
    >
      <Component />
    </span>
  );
};

export default Icon;
